import { render, staticRenderFns } from "./MigrationIntroduction.vue?vue&type=template&id=332cdda3"
import script from "./MigrationIntroduction.vue?vue&type=script&lang=js"
export * from "./MigrationIntroduction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports